module.exports = __webpack_public_path__ + "img/car-safety-road.ec02be24.png";